import { render } from "./RankingView.vue?vue&type=template&id=4572fbc9"
import script from "./RankingView.vue?vue&type=script&lang=js"
export * from "./RankingView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__